import React, { useEffect, useState } from 'react';
import '../styles/pantallaFinal.css';
import Nubes from './CajonPreguntas/Nubes';


//Imagenes
import podio from '../imgs/otros/podio.png';
import letreroColorido from '../imgs/otros/Letrero podio colorido.png';
import corona from '../imgs/otros/corona.png';
import flechaReinicio from '../imgs/otros/flecha-circular-en-sentido-horario.png';

//Libreria
import ReactHowler from 'react-howler';

//Sonidos
import sonidoFinalizacion from '../../src/sounds/tada-fanfare-a-6313.mp3';
import BanderaCuadros from './BanderaCuadros';

export default function PantallaFinal(props) {

  //Convertimos el prop con las puntuaciones en una variable
  let puntuacionesFinales = props.puntuaciones;

  //Creamos dos variables con arrays vacios uno para introducir los numeros de los resultados y poder ordenarlos y el otro con las posiciones.
  let ordenPosiciones = [];
  let posiciones = [];

  //haremos push para introducir cada valor de puntos en un array creado anteriormente.
  for(let i = 0; i < puntuacionesFinales.length; i++){
    ordenPosiciones.push(puntuacionesFinales[i].puntuacion);
  }

  //Ejecutamos la funcion sort para ordenar los puntos en el array que tenemos
  ordenPosiciones = ordenPosiciones.sort((a, b) => {return b - a});

  //Creamos dos for que compararan el array de puntos original y el array ordenado de los puntos y hacemos que haga push segun cada coincidencia en el orden del array de los puntos ordenados es decir si tenemos que en el array ordenado la puntuacion maxima es 15 buscamos en los puntos que ficho tenga esos puntos y los añadimos al array posiciones y lo eliminamos del array original y asi cuando de la segunda vuelta buscando el valor del segundo en puntos mas alto solo comparara con los tres restantes y añadira esa ficho y se eliminara del array original.etc
  for(let i = 0; i < ordenPosiciones.length; i++){
    for(let j = 0; j < puntuacionesFinales.length; j++){
      if(ordenPosiciones[i] === puntuacionesFinales[j].puntuacion){
        posiciones.push(puntuacionesFinales[j]);
        puntuacionesFinales.splice(j, 1);
      }
    }
  }


  console.log("posiciones",posiciones);
  //Por ultimo añadimos a el render las imagenes que tenemos de los fichos y sus posiciones para que se muestre en la pantalla final.

  return (
    <div className="pFinal__div--container">
      <ReactHowler src={sonidoFinalizacion} playing={props.finalJuego}/>
      <h1 className="pFinal__h1--juego-terminado">Juego terminado</h1>
      <img className="pFinal__img--letrero-colorido" src={letreroColorido} alt="letrero-colorido.png"/>
      {/* <Nubes/> */}
      <BanderaCuadros/>
      <div className="pFinal__div--podio">
        <img  className="pFinal__img--podio" src={podio} alt="podio.png" />


        {/*Fichos*/}

        {/*Corona*/}
        <img className="pFinal__img--corona" src={corona} alt="corona.jpg"/>

        <img className="pFinal__img--primer-puesto" src={posiciones[0].img} alt="ficho-primer-puesto.jpg"/>
        <img className="pFinal__img--segundo-puesto" src={posiciones[1].img} alt="ficho-segundo-puesto.jpg"/>
        <img className="pFinal__img--tercer-puesto" src={posiciones[2].img} alt="ficho-tercer-puesto.jpg"/>
        <img className="pFinal__img--cuarto-puesto" src={posiciones[3].img} alt="ficho-cuarto-puesto.jpg"/>
        <div className="pFinal__div--4"><p>4</p></div>
      </div>
      <button className='pFinal__button--reinicio' onClick={() => props.reiniciarPartida()}>Reiniciar partida</button>
    </div>
  )
}
